import * as d3 from 'd3';
import Holidays from 'date-holidays';
import mitt from 'mitt'

export const bus = mitt()

export const dayMs = 1000 * 60 * 60 * 24;
export const buffer = 5;
export const printHeaderHeight = 40;
export const rowHeight = 36;

export function cleanx(x, d) {
  return Math.round(x(d))
}
export function getWidthPerDay(isprintView) {
   return isprintView ? 21 : 60;
}

export function getRowHeight(isprintView) {
   return isprintView ? 25 : 36;
}


export const germanDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

export function snap(val, isprintView) {
  let widthPerDay = getWidthPerDay(isprintView)
	return Math.round(val / widthPerDay) * widthPerDay
}

export function nDaysLater(date, n) {
  const result = new Date(date);
  result.setDate(result.getDate() + n);
  return result;
}

export function nextDay(date) {
  return nDaysLater(date, 1);
}

export function isLastDayOfMonth(date) {
  return nextDay(date).getDate() === 1;
}

export function isWeekstart(date) {
  return date.getDay() === 1;
}

export function isFirstFullWorkWeek(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth();

  // 1. Find the first day of this month
  const firstDayOfMonth = new Date(year, month, 1);
  
  // 2. Find the first Monday of this month
  // getDay() is 0 for Sunday, 1 for Monday...
  let firstMonday = new Date(year, month, 1);
  while (firstMonday.getDay() !== 1) {
    firstMonday.setDate(firstMonday.getDate() + 1);
  }

  // 3. Determine if the week starting at 'firstMonday' is fully contained.
  // A week is fully contained if its Monday is the 1st of the month.
  // If the first Monday is the 2nd through 7th, we must check if 
  // the previous days (the 1st, etc.) belonged to the previous week.
  
  let firstFullWeekMonday;
  
  if (firstDayOfMonth.getDay() === 1) {
    // If the 1st is a Monday, the week of the 1st is the first full week.
    firstFullWeekMonday = firstDayOfMonth;
  } else {
    // If the 1st is NOT a Monday (Tue-Sun), the week containing the 1st 
    // started in the previous month. Therefore, the very first 
    // Monday of THIS month starts the first fully contained week.
    firstFullWeekMonday = firstMonday;
  }

  // 4. Compare the input date to our calculated First Full Week Monday
  return d.getTime() === firstFullWeekMonday.getTime();
}

export function isUserBooking(p, u, b) {
   return b.user_id === u.id
}

export function is_bookable(b, selectedDays) {
	if (!b.start || !b.end) {
		return false;
	}
	
	let firstDay = selectedDays[0];
	let lastDay   = selectedDays.at(-1);
	//console.log("firstDay=" + firstDay + " lastDay=" + lastDay)

	let isoFirst = formatDateYYYYMMDD(firstDay) + "T00:00:00.000Z"
	let isoLast  = formatDateYYYYMMDD(lastDay) + "T00:00:00.000Z"
	let intersects = new Date(b.end) >= new Date(isoFirst) && new Date(b.start) <= new Date(isoLast);
	//console.log("is_bookable b=" + JSON.stringify(b) + " selectedDays=" + JSON.stringify(selectedDays))
	//console.log("intersects" + intersects);
	return intersects;
}

export function isBookingInProject(p, b) {
  //console.log("isBookingInProject p=" + JSON.stringify(p) + " b=" + JSON.stringify(b))
  return is_bookable(b, [p.start, p.end]);
}

export function prepTask(pid2pnames, p, u, b) {
  let inproject = b.project_id === p.id
  let pname = pid2pnames[b.project_id.toString()]
  let label = u.short + (inproject ?  "" : ">" + pname)
  return {id: b.id,
	    start: b.start,
	    end: b.end,
		  color: p.color,
		  pname: pname,
      project_id: b.project_id,
		  inproject: inproject,
      label: label
  };
}

export function prepBooking(b) {	
//  console.log("prepBooking b=" + JSON.stringify(b))	
  const startDate =  new Date(b.start + "T00:00:00Z");
  const endDate = new Date(b.end + "T00:00:00Z");
//  console.log("prepBooking startDate=" + startDate)	
//  console.log("prepBooking endDate=" + endDate)	
  return {id: b.id, start: startDate, end: endDate, oldstart: b.start, oldend: b.end, user_id: b.user_id, project_id: b.project_id }
}


export function prepProject(p) {
	const startDate =  new Date(p.start + "T00:00:00Z");
	const endDate = new Date(p.end + "T00:00:00Z");
	return {id: p.id, name: p.name, description: p.description, status: p.status,
		 start: new Date(p.start), end: endDate, color: p.color, altname: p.altname }	
}

export function getBavariaHolidaysBetween(startDate, endDate) {
  const hd = new Holidays('DE', 'BY'); // Germany, Bavaria
  const holidays = [];

  for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
    const yearHolidays = hd.getHolidays(year);
    yearHolidays.forEach(h => {
      const d = new Date(h.date);
      if (h.type === "public" && d >= startDate && d <= endDate) {
        holidays.push({ name: h.name, date: d });
      }
    });
  }

  return holidays;
}

export function createAxisLine(startDate, endDate, data, format, getEnd = null, withWeekends = false, withHolidays = false, isprintView = false, extraClassLine = "", extraClassCell = "") {
  const line = document.createElement("div");
  const holidays = getBavariaHolidaysBetween(startDate, endDate);
  const widthPerDay = getWidthPerDay(isprintView);

  line.className = "time-axis-line" + extraClassLine + (isprintView ? " printview" : "");

  data.forEach((d, i) => {
    // 1. Determine the logical start and end of THIS specific cell
    let cellStart = d;
    let cellEnd = getEnd ? getEnd(data, i) : d3.timeDay.offset(d, 1);

    // 2. CLIPPING: Ensure the cell doesn't go outside the axis boundaries
    // If the week starts before the axis, cut the start to match startDate
    const actualStart = cellStart < startDate ? startDate : cellStart;
    // If the week ends after the axis, cut the end to match endDate
    const actualEnd = cellEnd > endDate ? endDate : cellEnd;

    // 3. Calculate span only for the visible portion
    const spanMs = actualEnd - actualStart;
    const spanDays = spanMs / dayMs;

    // Skip rendering if the cell is completely outside the visible range
    if (spanDays <= 0) return;

    const cell = document.createElement("div");
    cell.className = "time-axis-cell" + (isprintView ? " printview" : "") + extraClassCell;
    
    const isWeekend = d.getDay() === 0 || d.getDay() === 6;
    const isHoliday = holidays.some(h => h.date.toDateString() === d.toDateString());

    if (withWeekends && isWeekend) {
      cell.classList.add("weekend");
    }

    if (withHolidays && isHoliday) {
      cell.classList.add("holiday");
    }

    cell.style.width = `${spanDays * widthPerDay}px`;
    cell.textContent = format(d, i);
    line.appendChild(cell);
  });
  
  return line;
}

export function daysBetween(date1, date2) {
  const msPerDay = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  let bet = Math.floor(Math.abs(utc2 - utc1) / msPerDay);
  return bet < 7 ? bet : 7;
}


export function isHttpSuccess(xhr) {
    return xhr.status >= 200 && xhr.status < 300;
}

export function sendRequest(url, params, onSuccess, onFailure, method='POST') {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, true); // async

  xhr.setRequestHeader('Content-Type', 'application/json');
  var token = document.querySelector('meta[name="csrf-token"]').content;
  xhr.setRequestHeader('X-CSRF-Token', token);

  xhr.onload = function() {
    let response = {};
    try { response = JSON.parse(xhr.responseText); } catch(e) {}
    if (isHttpSuccess(xhr)) {
      onSuccess(response);
    } else {
      onFailure(response);
    }
  };

  xhr.onerror = function() {
    onFailure({ error: 'Netzwerkfehler' });
  };

  console.log("sendRequest params=" + JSON.stringify(params));
  xhr.send(JSON.stringify(params));
}

export function getBookings(project, bookings) {
	if (!bookings || bookings.length === 0) {
		return []
	}
	
	if (project.id === 0) {
		return bookings
	}
	
	return bookings.filter(b => b.project_id === project.id)	
}

function getBookingsFromSelection(selectedCells, target_pid = null) {
    let bookings = []
    selectedCells.forEach(cell => {
      let idparts = cell.id.split('-');
      let when = idparts[idparts.length - 1] 
      let uid  = idparts[idparts.length - 2]
      let pid  = target_pid === null ? idparts[idparts.length - 3] : target_pid;
      let targetDate = getDateNDaysFromNow(startdate, parseInt(when));
      let day   = targetDate.getDate().toString();
      let month = (targetDate.getMonth() + 1).toString();
      let year  = targetDate.getFullYear().toString();
      let booking = {"when(3i)": day, "when(2i)": month, "when(1i)": year, user_id: uid, project_id: pid};
      console.log("booking:" + JSON.stringify(booking));
      bookings.push({booking: booking})
    });
    return bookings;
}  

export function pixel2int(px) {
	return parseInt(px.slice(0, -2))
}

export function box2int(box) {
	return Object.fromEntries(Object.entries(box).map(([key, value]) => [key, pixel2int(value)]));
}

export function sortProjects(projects) {
    return projects.sort((a, b) => a.name.localeCompare(b.name));
}

export function popupProjectsList(projects) {
	return projects.filter(p => p.status !== 1).sort((a, b) => a.name.localeCompare(b.name));
}

export function userFromRow(users, row) {
  //console.log("row id=" + row.id);
  let s = row.id.split('-');
  if (s.length < 2) {
	return [null, null]
  }
  let uid = s[1];
  return [users.find(u => u.id.toString() === uid), parseInt(s[0])];
}

/*
export function getResourceRange(b, users, timesheet) {
	let timesheet_rect = timesheet.getBoundingClientRect();
	let starty = b.y + timesheet_rect.y;

	let sel_range = [];
	let selected_pid = null;
	let u = null;
	document.querySelectorAll(".resource-row").forEach(div => {
		const rect = div.getBoundingClientRect();

		  const intersects = (rect.y >= starty) && rect.y < (starty + b.height);

		  if (intersects) {
			[u, selected_pid] = userFromRow(users, div);
			sel_range.push(u);
		  }
	});
	return [sel_range, selected_pid];
}
*/

export function getResourceRange(b, users, timesheet) {
	let sel_range = [];
	let main_pid = null;
	let u = null;
	
	let startRow = b.y / rowHeight;
	let endRow = startRow + b.height / rowHeight;
	//console.log("startRow=" + startRow + " endRow=" + endRow)
	let k = 0;
	document.querySelectorAll(".resource-row").forEach(div => {
		//console.log("div id=" + div.id)
		const rect = div.getBoundingClientRect();
		let [u, selected_pid] = userFromRow(users, div);
		
		//console.log("k=" + k)
		if (k >= startRow && k < endRow && u) {
      if (selected_pid !== null) {
			  main_pid = selected_pid
		  }

			//console.log("found resource=" + JSON.stringify(u) + " selected_pid=" + selected_pid)
			sel_range.push(u);
		}
		k++
	});
	//console.log("sel_range=" + JSON.stringify(sel_range) + " main_pid=" + main_pid)

	return [sel_range, main_pid];
}

export function snapDim(length, unit) {
  return Math.round(length / unit) * unit;
}

export function setDim(rect, l, t, w, h, unitw, unith) {

  let sl = snapDim(l, unitw);
  let st = snapDim(t, unith);
  let sw = snapDim(w, unitw);
  let sh = snapDim(h, unith);
  rect.style.left = `${sl}px`;
	rect.style.top = `${st}px`;
	rect.style.width = `${sw}px`;
	rect.style.height = `${sh}px`;

  console.log("rect.style.left=" + sl + " rect.style.top=" + st + " rect.style.width=" + sw + " rect.style.height=" + sh);
}

export function getProjectBookings(bookings, p) {
	console.log("p=" + JSON.stringify(p))
	return (p.id === 0) ? bookings : bookings.filter(b => b.project_id === p.id);		
}


export function getUserBookings(pid2pnames, bookings, p, u, isprintView) {
  let bs = bookings.filter(b => isUserBooking(p, u, b)).filter(b => (b.project_id === p.id || isBookingInProject(p, b)) && (isprintView ? p.id === b.project_id : true)).map(b => prepTask(pid2pnames, p, u, b))
  return  Array.from(bs);
}

export function removeLastn(str, n) {
  console.log("str.substring(0, str.length - 3)=" + str.substring(0, str.length - 3));
  return str.substring(0, str.length - 3);
}

export function getProjectFromRow(e, projects) {
  let row = e.target.closest(".resource-row");
  if (!row || !row.id) {
	return null;
  }
  console.log("getProjectFromRow id=" + row.id)
  let id_split = row.id.split('-');
  if (id_split.length < 2) {
	return null;
  }
  let pid = parseInt(id_split[0]);
  if (isNaN(pid)) {
	return null;
  }
  return projects.find(p => p.id === pid) ?? null;

}


export function formatDateDDMMYYYY(date, sep='-') {
  const day = String(date.getUTCDate()).padStart(2, "0");      // Day with leading zero
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
  const year = date.getFullYear();

  return `${day}${sep}${month}${sep}${year}`;
}

export function formatDateYYYYMMDD(date, sep='-') {
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${year}${sep}${month}${sep}${day}`;
}

export function formatDateYYMMDD(date, sep = '-') {
  const day = String(date.getDate()).padStart(2, "0");            // Day (Local)
  const month = String(date.getMonth() + 1).padStart(2, "0");     // Month (0-indexed)
  
  // Get 4-digit year, convert to string, and take last 2 characters
  const year = String(date.getFullYear()).slice(-2);              

  return `${year}${sep}${month}${sep}${day}`;
}

export function germanToISODate(germanDate) {
	return new Date(germanToISO(germanDate));
}

export function germanToISO(germanDate) {
  // Convert "dd.mm.yyyy" → "yyyy-mm-dd"
  const [day, month, year] = germanDate.split("-");
  if (!day || !month || !year) return "";
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function isoToGerman(isoDate) {
  // Convert "yyyy-mm-dd" → "dd.mm.yyyy"
  const [year, month, day] = isoDate.split("-");
  if (!year || !month || !day) return "";
  return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
}

export function getDateUTC(date) {	
  return new Date(formatDateYYYYMMDD(date) + "T00:00:00");
}

export function utcToLocal(date) {
  const utcDate = new Date(date);
  
  // getTimezoneOffset returns the difference in minutes 
  // between UTC and local time (e.g., -60 for GMT+1)
  const offsetInMilliseconds = utcDate.getTimezoneOffset() * 60000;
  
  // We subtract the offset because getTimezoneOffset() is 
  // (UTC - local), so subtracting it effectively adds the local difference.
  return new Date(utcDate.getTime() - offsetInMilliseconds);
}

export function getXDateUTC(x, xpos) {
	return getDateUTC(x.invert(xpos));
}

export function germanDateToUTC(german) {
	if (german == null) {
		return null;
	}
	return getDateUTC(new Date(germanToISO(german)));
}

export function isoDateToUTC(iso) {
	if (iso == null) {
		return null;
	}
	return new Date(iso + "T00:00:00");
}

export function scrollToToday(x) {
  const targetX = cleanx(x, new Date()) - 100;
  document.getElementById('main-scroll-area').scrollLeft = Math.max(0, targetX);
};

export function applyResoureFilter(resourceFilter, p, u) {
  let rf = resourceFilter;
  return rf.selection === 1 ? rf.individual.includes(u.id) : rf.hasBookings.includes(u.id);
}

export function hasBookings(p, users, bookings) {
  let hb = [];
  for (const u of users) {
    if (bookings.some(b => b.project_id === p.id && b.user_id === u.id)) {
      hb.push(u.id);
    }
  }
  return hb;
}

export function computeResourceFilter(view, projects, users, bookings) {
  
  let resourceFilter = {};
  for (const p of projects) {
    let rf = view.getResourceFilter(p.id);
	resourceFilter[p.id] = {selection: rf.selection, individual: rf.individual, hasBookings: hasBookings(p, users, bookings)};
  }
  //console.log("hasBookings=" + JSON.stringify(hasBookings))
  return resourceFilter;
}

export function removeSelections() {
  document.querySelectorAll(".editable").forEach(t => t.classList.remove("editable"));
  document.querySelectorAll(".highlight-bar").forEach(t => t.classList.remove("highlight-bar"));
}

export async function generateTiledPdf(
  project,
  timesheetEl,
  cornerEl,
  sidebarEl,
  html2canvas,
  jsPDF,
  onProgress
) {

// 1. CREATE A WRAPPER THAT IS "OFF-SCREEN" BUT VISIBLE TO THE BROWSER
  const offscreenContainer = document.createElement('div');
  Object.assign(offscreenContainer.style, {
    position: 'absolute',
    top: '0',
    left: '-10000px',        // Move it way off-screen
    width: 'max-content',
    visibility: 'visible',   // MUST be visible for html2canvas
    pointerEvents: 'none'    // Prevent user interaction
  });
  document.body.appendChild(offscreenContainer);

  // 2. CLONE AND RESET SCROLL
  const timesheetClone = timesheetEl.cloneNode(true);
  const sidebarClone = sidebarEl.cloneNode(true);
  
  // Ensure the clones themselves aren't holding internal scroll offsets
  timesheetClone.scrollLeft = 0;
  timesheetClone.scrollTop = 0;
  sidebarClone.scrollTop = 0;

  offscreenContainer.appendChild(sidebarClone);
  offscreenContainer.appendChild(timesheetClone);

  const pdf = new jsPDF("l", "mm", "a4");

  // --- MARGINS ---
  const marginL = 10;
  const marginR = 10;
  const marginT = 20;
  const marginB = 10;

  const pageWidthMm = pdf.internal.pageSize.getWidth();
  const pageHeightMm = pdf.internal.pageSize.getHeight();

  const pxToMm = (px) => (px * 25.4) / 96;
  const mmToPx = (mm) => (mm * 96) / 25.4;

  const scaleFactor = 2;

  const sidebarWidthMm = pxToMm(sidebarEl.offsetWidth);
  const cornerHeightMm = pxToMm(cornerEl.offsetHeight);

  // --- 1. PRE-RENDER THE LOGO (SMALLER SCALE) ---
  const cornerCanvas = document.createElement('canvas');
  const ctx = cornerCanvas.getContext('2d');
  const logoImg = cornerEl.querySelector('img');

  const scale = scaleFactor;
  cornerCanvas.width = cornerEl.offsetWidth * scale;
  cornerCanvas.height = cornerEl.offsetHeight * scale;

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, cornerCanvas.width, cornerCanvas.height);

  if (logoImg && logoImg.complete) {
      const aspectRatio = logoImg.naturalWidth / logoImg.naturalHeight;
      
      // SCALE: Reduced to 35% of container width
      const destWidth = (cornerEl.offsetWidth * 0.35) * scale; 
      const destHeight = destWidth / aspectRatio;
      
      // POSITIONING: 8px padding for a cleaner look
      const padding = 8 * scale;
      
      // Optional: High-quality scaling
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      ctx.drawImage(logoImg, padding, padding, destWidth, destHeight);
  }

  const cornerImg = cornerCanvas.toDataURL("image/jpeg", 0.95);

  // --- TRUE dimensions (NO -1 hacks) ---
  const totalWidth = timesheetEl.scrollWidth;
  const totalHeight = cornerEl.scrollHeight + sidebarEl.scrollHeight;

  // --- USABLE GRID WIDTH ---
  const usableGridWidthMm =
    pageWidthMm - marginL - marginR - sidebarWidthMm;

  const rawPxGridPageWidth = mmToPx(usableGridWidthMm);

  // Snap to full day width (ALL IN PX)
  const widthPerDayPx = getWidthPerDay(true);

  const pxGridPageWidth =
    Math.floor(rawPxGridPageWidth / widthPerDayPx) *
    widthPerDayPx;

  // --- USABLE HEIGHT ---
  const usableHeightMm = pageHeightMm - marginT - marginB;
  const pxPageHeight = Math.floor(mmToPx(usableHeightMm));

  const cols = Math.ceil(totalWidth / pxGridPageWidth);
  const rows = Math.ceil(totalHeight / pxPageHeight);
  const totalSteps = cols * rows;

  let currentStep = 0;

  await new Promise(r => setTimeout(r, 100));

  for (let y = 0; y < totalHeight; y += pxPageHeight) {
    const remainingHeight = totalHeight - y;
    const capturedPxHeight = Math.min(
      pxPageHeight,
      remainingHeight
    );

    if (capturedPxHeight <= 1) continue;

    const sliceHeightMm = pxToMm(capturedPxHeight);

    // --- SIDEBAR SLICE ---
    const sidebarSliceCanvas = await html2canvas(sidebarClone, {
        scale: scaleFactor,
        useCORS: true,
        width: sidebarEl.offsetWidth,
        height: capturedPxHeight,
        x: 0,
        y: y,
        scrollX: 0,
        scrollY: 0, // The clone isn't scrolled, so 0 is absolute
    });

    const sidebarSliceImg = sidebarSliceCanvas.toDataURL("image/jpeg", 0.95);

    for (let x = 0; x < totalWidth; x += pxGridPageWidth) {
      const remainingWidth = totalWidth - x;
      const capturedPxWidth = Math.min(pxGridPageWidth, remainingWidth);
      if (capturedPxWidth <= 1) continue;

      // --- DIRECT CAPTURE METHOD (Faster & More Reliable) ---
      const canvas = await html2canvas(timesheetClone, {
          scale: scaleFactor,
          useCORS: true,
          logging: false,    // Clean up console
          width: capturedPxWidth + 2,
          height: capturedPxHeight,
          x: x,
          y: y,
          scrollX: 0, 
          scrollY: 0,
          backgroundColor: '#ffffff' // Ensure no transparency
      });
      const imgData = canvas.toDataURL("image/jpeg", 0.85);

      if (currentStep > 0) pdf.addPage();
      currentStep++;

      // --- DRAW CORNER ---
      pdf.addImage(cornerImg, "JPEG", 0, 0, sidebarWidthMm, cornerHeightMm);

      // --- DRAW SIDEBAR ---
      pdf.addImage(sidebarSliceImg, "JPEG", marginL, marginT + cornerHeightMm, sidebarWidthMm, sliceHeightMm);

      pdf.addImage(imgData, "JPEG", marginL + sidebarWidthMm, marginT, pxToMm(capturedPxWidth), sliceHeightMm);

      // --- HEADER TEXT ---
      pdf.setFontSize(10);
      pdf.setTextColor(100);

      let title = project.name + " " + project.description
      pdf.setFont("helvetica", "bold");
      pdf.text(title, marginL + sidebarWidthMm, marginT - 5);

      pdf.setFont("helvetica", "normal");
      pdf.text("Personalplan Ausgabedatum ", marginL + sidebarWidthMm, marginT + 2);

      pdf.setFont("helvetica", "bold");
      pdf.text(formatDateDDMMYYYY(new Date(), "."), marginL + sidebarWidthMm + 51, marginT + 2);

      // --- PAGE NUMBER ---
      const pageText = `${currentStep} / ${totalSteps}`;
      const textWidth =
        (pdf.getStringUnitWidth(pageText) *
          pdf.getFontSize()) /
        pdf.internal.scaleFactor;

      pdf.setFont("helvetica", "normal");
      pdf.setTextColor(50);

      pdf.text(
        pageText,
        pageWidthMm - marginR - textWidth,
        pageHeightMm - marginB / 2,
      );

      pdf.text(
        "Team",
        marginR + 2.7,
        61,
      );

      if (onProgress) {
        onProgress((currentStep / totalSteps) * 100);
      }
    }
  }

  const fileName = project.name + " Personalplan TI " + formatDateYYMMDD(new Date(), "");

  pdf.save(`${fileName}.pdf`);
}


export function getWeekBounds(startDateStr, endDateStr) {
  // Helper to parse DD-MM-YYYY into a Date object
  
  const parseDate = (str) => {
    const [day, month, year] = str.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  // Helper to format Date object back to DD-MM-YYYY
  const formatDate = (date) => {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}-${m}-${y}`;
  };

  let start = parseDate(startDateStr);
  let end = parseDate(endDateStr);

  // 1. Find the earliest Monday
  // getDay(): Sun=0, Mon=1, Tue=2...
  // If day is 0 (Sun), we need to go back 6 days.
  // If day is 1 (Mon), we go back 0 days.
  const startDay = start.getDay();
  const diffToMonday = startDay === 0 ? 6 : startDay - 1;
  start.setDate(start.getDate() - diffToMonday);

  // 2. Find the latest Sunday
  // If day is 0 (Sun), we stay.
  // If day is 1 (Mon), we add 6 days.
  const endDay = end.getDay();
  const diffToSunday = endDay === 0 ? 0 : 7 - endDay;
  end.setDate(end.getDate() + diffToSunday);

  return {
    earliestMonday: formatDate(start),
    latestSunday: formatDate(end)
  };
}

let scrollVelocity = 0;
let isAutoScrolling = false;
let containerRef = null;

function step() {
  if (!isAutoScrolling) return;

  if (scrollVelocity === 0 || !containerRef) {
    isAutoScrolling = false;
    return;
  }

  containerRef.scrollLeft += scrollVelocity;

  requestAnimationFrame(step);
}

export function startAutoScroll(container, velocity) {
  containerRef = container;
  scrollVelocity = velocity;

  if (!isAutoScrolling) {
    isAutoScrolling = true;
    requestAnimationFrame(step);
  }
}

export function updateAutoScroll(velocity) {
  scrollVelocity = velocity;
}

export function stopAutoScroll() {
  isAutoScrolling = false;
  scrollVelocity = 0;
}

export function handleAutoScroll(e) {
  console.log("window.__POINTER_DOWN__=" + window.__POINTER_DOWN__)
  const container = document.querySelector('.main-scroll-area');
  if (!container) return;

  if (!window.__POINTER_DOWN__) {
    stopAutoScroll();
    return;
  }

  const rect = container.getBoundingClientRect();
  const clientX = e.touches ? e.touches[0].clientX : e.clientX;

  const EDGE = 60;
  const MAX_SPEED = 40;

  const leftEdge  = Math.max(rect.left, 0);
  const rightEdge = Math.min(rect.right, window.innerWidth);

  if (clientX < leftEdge + EDGE) {
    const distance = leftEdge + EDGE - clientX;
    const velocity = -Math.min(MAX_SPEED, distance * 0.5);
    startAutoScroll(container, velocity);
  } 
  else if (clientX > rightEdge - EDGE) {
    const distance = clientX - (rightEdge - EDGE);
    const velocity = Math.min(MAX_SPEED, distance * 0.5);
    startAutoScroll(container, velocity);
  } 
  else {
    stopAutoScroll();
  }
}

export function positionTodayLine(id, x) {
	const todayLine = document.getElementById(id);
	const today = new Date();
  today.setHours(0, 0, 0, 0);
	todayLine.style.left = `${cleanx(x, today)}px`;
}

function normalizeDate(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
function filterBookingForDay(b, d, debug) {
  d = normalizeDate(d);
  let s = normalizeDate(b.start);
  let e = normalizeDate(b.end);
  return d >= s && d <= e;
}

export function countBookingsForDay(view, project, bookings, d) {
 // console.log("countBookingsForDay project_id=" + project.id + " bookings=" + JSON.stringify(bookings))
	let count = bookings.filter(b => filterBookingForDay(b, d, b.id === 17 && project.id === 41)).length
	if (project.id === 0) {
		count = view.countActiveUsers - count
	}
	return count
}

export function isCloseToMultiple(x, m, eps) {
  let r = x % m;
  return Math.min(r, m - r) < eps;
}

export function validateProjectDuration(project, bstart, bend) {
  let extendsProjectDuration = false;
	//bstart = getDateUTC(bstart);
	//bend = getDateUTC(bend);
  let pstart = getDateUTC(project.start);
  let pend = getDateUTC(project.end);
  console.log("bstart=" + bstart + " bend=" + bend + " pstart=" + pstart + " pend=" + pend)
  let newpstart = pstart;
  let newpend = pend;
  if (bstart < pstart || bend > pend) {
    extendsProjectDuration = true;
    if (bstart < pstart) {
      newpstart = bstart;
    }
    if (bend > pend) {
      newpend = bend;
    }
  }

  if (extendsProjectDuration && !window.confirm("Diese Buchung erweitert den Projektzeitraum von " + formatDateDDMMYYYY(utcToLocal(newpstart)) + " bis zu " + formatDateDDMMYYYY(utcToLocal(newpend)) + ". Möchten Sie das wirklich?")) {
      return [false, true]
  }

  return [true, extendsProjectDuration, newpstart, newpend];
}
